/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mixins } from '@blend/consumer-components';

const styles = StyleSheet.create({
  content: mixins.margin(0),
  isInline: {
    lineHeight: 0,
  },
  // inline text without icon
  inlineTextWrapper: {
    display: 'inline',
  },
});

export namespace LinkButtonContentWrapper {
  export interface Props {
    isInlineText?: boolean;
    isInline?: boolean;
  }
}

export const LinkButtonContentWrapper: React.FC<LinkButtonContentWrapper.Props> = ({
  children,
  isInlineText,
  isInline,
}) => {
  return <div className={css(isInlineText ? styles.inlineTextWrapper : !isInline && styles.content)}>{children}</div>;
};
